module.exports = __webpack_public_path__ + "img/piano.95ac8f24.svg";